import { ScrollableDialogProps } from "../Dialogs";
// import LoaderComponent from "../LoaderComponent";
import { Grid } from "@mui/material";
import { gridSizeMdLg6 } from "@/shared";
import { texto } from "@/shared/utils";
import CustomTextFieldNoForm from "../CustomTextFieldNoForm";
import { useInfoCoordenadasStore } from "./useInfoCoordendas.store";
import { NacionalidadEnum } from "@/shared/interfaces";
import { MapModalComponent } from "@/erp/tecnico/orden-trabajo/shared/components";

export default function InfoCoordendas() {

  const { open, setOpen, zone_data, coordenadas, sector } = useInfoCoordenadasStore()

  // if (isLoading) return <LoaderComponent />
  // console.log({zone_data})

  return (
    <>
      {
        open && zone_data && (
          <ScrollableDialogProps
            onCloseIcon={() => setOpen(false)}
            open={open}
            title="Localización"
            minWidth="48%"
            contentNode={
              <Grid container spacing={3}>
                {
                  zone_data?.nombre?
                  <>
                    <CustomTextFieldNoForm
                      disabled={true}
                      defaultValue={NacionalidadEnum.ECUADOR}
                      value={NacionalidadEnum.ECUADOR}
                      size={gridSizeMdLg6}
                      label={texto.pais}
                    />
    
                    <CustomTextFieldNoForm
                      disabled={true}
                      defaultValue={NacionalidadEnum.ECUADOR}
                      value={NacionalidadEnum.ECUADOR}
                      size={gridSizeMdLg6}
                      label={texto.pais}
                    />
    
                    <CustomTextFieldNoForm
                      disabled={true}
                      defaultValue={zone_data?.provincia_data?.nombre}
                      value={zone_data?.provincia_data?.nombre}
                      size={gridSizeMdLg6}
                      label={texto.provincia}
                    />
    
                    <CustomTextFieldNoForm
                      disabled={true}
                      defaultValue={zone_data?.ciudad_data?.nombre}
                      value={zone_data?.ciudad_data?.nombre}
                      size={gridSizeMdLg6}
                      label={texto.ciudad}
                    />
    
                    <CustomTextFieldNoForm
                      disabled={true}
                      defaultValue={zone_data?.nombre}
                      value={zone_data?.nombre}
                      size={gridSizeMdLg6}
                      label={texto.zona}
                    />
    
                    <CustomTextFieldNoForm
                      disabled={true}
                      defaultValue={sector ?? 'N/A'}
                      value={sector ?? 'N/A'}
                      size={gridSizeMdLg6}
                      label={texto.sector}
                    />
                  </>
                  :
                  ""
                }
              </Grid>
            }
          />
        )
      }
      {
        open && !!coordenadas &&  coordenadas!="0,0" ? (
          <MapModalComponent
            title="Coordenadas de Servicio"
            open={open}
            onClose={()=>setOpen(false)}
            coords={coordenadas!}
          />
        ):null
      }
    </>
  )

}